import { faArrowCircleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MutableRefObject, useEffect, useState } from "react";
import { Dispatch, SetStateAction } from "react";
import { FormProvider, useForm } from "react-hook-form";
import {
    CalculaDescontoJurosMultaController,
    GetMelhorAlcadaHonorarioController,
} from "../../../Controllers/Cobranca/AlcadaDesconto/AlcadaDescontoController";
import useAsyncCallback from "../../../hooks/useAsyncCallback";

import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { IAlcadaHonorario } from "../../../Interfaces/Cobranca/AlcadaDesconto/AlcadaDescontoInterface";
import { IParcelaBoletos } from "../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import UnForm from "../../Form";

interface IDescontoHonorariosProps {
    ID_CASO?: number;
    ID_CONTA: number;
    lstParcelasBoletosRequest: Array<IParcelaBoletos>;
    setPorcentagemHonorario: Dispatch<SetStateAction<number>>;
    setPorcentagemJuros: Dispatch<SetStateAction<number>>;
    setPorcentagemMulta: Dispatch<SetStateAction<number>>;

    porcentagemJuros?: number;
    porcentagemMulta?: number;

    porcentagemHonorario: number;
    setBloqueioHonorario: Dispatch<SetStateAction<boolean>>;

    bloqueioHonorario: boolean;
    setBloqueioDescontoAlcada: Dispatch<SetStateAction<boolean>>;
    setHonorario: Dispatch<SetStateAction<number>>;
    porcentagemHonorarioSaved: MutableRefObject<number>;
}

export default function DescontoHonorarios(props: IDescontoHonorariosProps) {
    const [aplicandoHonorario, setAplicandoHonorario] = useState(false);
    const FormMethods = useForm();
    const { formState, reset, handleSubmit } = FormMethods;

    const {
        ID_CASO,
        lstParcelasBoletosRequest,
        setHonorario,
        porcentagemHonorario,
        setBloqueioDescontoAlcada,
        setPorcentagemHonorario,
        porcentagemJuros,
        porcentagemMulta,
    } = props;

    const { value: HonorarioAplicado } = useAsyncEffect(async () => {
        return GetMelhorAlcadaHonorarioController(ID_CASO ?? 0);
    }, [ID_CASO]);

    function isDataMenorSeisDias() {
        return lstParcelasBoletosRequest.some((prc) => {
            const dataAtual = new Date();
            const dataParcelaObj = new Date(prc.Data_Prc);

            const diferencaMilissegundos =
                dataAtual.getTime() - dataParcelaObj.getTime();

            const diferencaDias = Math.floor(
                diferencaMilissegundos / (1000 * 60 * 60 * 24)
            );
            // REGRA DE NEGOCIO: conseguir aplicar HONORARIO quando cliente estiver com 6 ou mais dias de inadimplência.
            return diferencaDias < 6;
        });
    }

    const { execute: HandleHonorarioForm } = useAsyncCallback(
        async (formData: IAlcadaHonorario) => {
            setAplicandoHonorario(true);
            setBloqueioDescontoAlcada(true);

            setPorcentagemHonorario(formData.NUM_PERCENTUAL_HONORARIO);
            if (porcentagemHonorario > 0) {
                props.porcentagemHonorarioSaved.current = porcentagemHonorario;
            }
            if (
                ID_CASO &&
                lstParcelasBoletosRequest.length > 0 &&
                aplicandoHonorario
            ) {
                await CalculaDescontoJurosMultaController(
                    lstParcelasBoletosRequest,
                    ID_CASO,
                    porcentagemJuros ?? 0,
                    porcentagemMulta ?? 0,
                    formData.NUM_PERCENTUAL_HONORARIO > 0
                        ? formData.NUM_PERCENTUAL_HONORARIO
                        : 0
                ).then((res) => {
                    setHonorario(res.HONORARIO);
                });
            }
        },
        [lstParcelasBoletosRequest, ID_CASO, setHonorario, aplicandoHonorario]
    );

    useEffect(() => {
        if (lstParcelasBoletosRequest.length > 0 && aplicandoHonorario)
            handleSubmit(HandleHonorarioForm)();
        else setHonorario(0);
    }, [
        handleSubmit,
        lstParcelasBoletosRequest,
        HandleHonorarioForm,
        setHonorario,
        aplicandoHonorario,
    ]);

    return HonorarioAplicado ? (
        <>
            <div
                id="accordion"
                className="card card-custom w-auto ml-auto wave wave-animate-slow wave-info border-bottom border-1 border-dark"
            >
                <div className="card-header p-1">
                    <div id="headingtwo">
                        <h5 className="mb-0">
                            <button
                                className="btn btn-link text-decoration-none"
                                data-toggle="collapse"
                                data-target="#collapsetwo"
                                aria-expanded="true"
                                aria-controls="collapsetwo"
                            >
                                <div className="d-flex flex-wrap justify-content-between m-1 align-items-center">
                                    <h2 className="p-0 m-0">
                                        PORCENTAGEM DE HONORÁRIO
                                        <FontAwesomeIcon
                                            icon={faArrowCircleDown}
                                            className="ml-1 mr-1"
                                        />
                                    </h2>
                                </div>
                            </button>
                        </h5>
                    </div>
                </div>

                <div
                    id="collapsetwo"
                    className="panel-collapse collapse"
                    aria-labelledby="headingtwo"
                    data-parent="#accordion"
                >
                    <div className="d-flex flex-wrap justify-content-between mb-5 p-3">
                        <div>
                            Não existe um número mínimo de parcelas a serem
                            selecionadas para aplicar o Honorário.
                        </div>
                        <FormProvider {...FormMethods}>
                            <UnForm
                                usingContext
                                handleSubmit={HandleHonorarioForm}
                                id="formHonorario"
                                className="w-100 align-itens-center d-flex flex-wrap justify-content-between mt-3"
                            >
                                <div className="d-flex flex-row align-items-end">
                                    <div>
                                        <label htmlFor="PERCENTUAL_HONORARIO">
                                            {" "}
                                            Honorário:{" "}
                                        </label>
                                        <UnForm.Input
                                            type="number"
                                            name="NUM_PERCENTUAL_HONORARIO"
                                            maxLength={2}
                                            placeholder={"Honorário"}
                                            defaultValue={0}
                                            step={0.1}
                                            disabled={
                                                isDataMenorSeisDias() ||
                                                porcentagemHonorario > 0
                                            }
                                            max={
                                                HonorarioAplicado.NUM_PERCENTUAL_HONORARIO
                                            }
                                            className={`form-control px-0 p-2 mr-3 w-100 placeholder-muted-75  ${
                                                formState.errors
                                                    .NUM_PERCENTUAL_HONORARIO &&
                                                "is-invalid"
                                            }`}
                                        />
                                    </div>
                                    <span className="pb-3 ml-1">
                                        Percentual máximo de:{" "}
                                        {
                                            HonorarioAplicado.NUM_PERCENTUAL_HONORARIO
                                        }
                                        %
                                    </span>
                                </div>

                                <div>
                                    {!aplicandoHonorario ? (
                                        <span>
                                            <button
                                                type="submit"
                                                form="formHonorario"
                                                onClick={() => {
                                                    if (aplicandoHonorario)
                                                        handleSubmit(
                                                            HandleHonorarioForm
                                                        )();
                                                }}
                                                className="btn btn-outline-primary font-weight-bold d-flex justify-content-center m-1"
                                            >
                                                Aplicar Honorários
                                            </button>
                                        </span>
                                    ) : (
                                        <div>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setHonorario(0);
                                                    setPorcentagemHonorario(0);
                                                    setAplicandoHonorario(
                                                        false
                                                    );
                                                    setBloqueioDescontoAlcada(
                                                        false
                                                    );

                                                    reset();
                                                }}
                                                className="btn btn-outline-danger font-weight-bold d-flex justify-content-center m-1"
                                            >
                                                Remover
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </UnForm>
                        </FormProvider>
                    </div>
                </div>
            </div>
        </>
    ) : (
        <></>
    );
}
